/**
 * Utility functions to replace Node.js util module usage
 */

/**
 * Check if a value is null or undefined
 * @param {*} value - The value to check
 * @returns {boolean} - True if value is null or undefined
 */
export const isNullOrUndefined = (value) => {
    return value === null || value === undefined;
};
